export default __webpack_public_path__ + "static/media/triangle-circumference.caa5314d.svg";